import { constant } from "./SystemConfigActionsConstants";
let initialState = {
    getSystemConfigInProgress:false
}

export const SystemConfigReducer = (state = initialState  , action ) =>{
    switch(action.type){
        case constant.GET_SYSTEM_CONFIG_IN_PROGRESS:
            return{...state , getSystemConfigInProgress:true};
        case constant.GET_SYSTEM_CONFIG_COMPLETE:
            return{...state , getSystemConfigInProgress:false ,systemConfig:action.data}
        default :
            return state
    }
}
  
export default SystemConfigReducer;